import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { subMonths } from 'date-fns'
import { Subject, debounceTime, takeUntil } from 'rxjs'
import { getTimeZoneLabel } from '../../utils/date.utils'

@Component({
  selector: 'app-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss'],
  standalone: false,
})
export class DatetimePickerComponent implements OnInit, OnDestroy {
  @Output() datetimeChanged = new EventEmitter<Date>()
  @Input() date: string | undefined
  @Input() disabled = false

  private dateChanged$ = new Subject<void>()
  private cleanUp$ = new Subject<void>()

  public minDate = subMonths(new Date(), 6)
  public maxDate = new Date()

  ngOnInit(): void {
    if (this.date) {
    }

    this.dateChanged$.pipe(debounceTime(500), takeUntil(this.cleanUp$)).subscribe(() => {
      if (this.date) {
        const date = new Date(this.date)
        date.setHours(0, 0, 0, 0)
        this.datetimeChanged.emit(date)
      }
    })
  }

  ngOnDestroy(): void {
    this.cleanUp$.next()
    this.cleanUp$.complete()
  }

  onChange(time: string): void {
    const date = new Date(time)
    date.setHours(0, 0, 0, 0)
    this.date = date.toISOString()
    this.dateChanged$.next()
  }
}
